import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function DealRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/recent");
  }, [navigate]);

  return (
    <div className="paddedContainer">
      <h1>Redirecting...</h1>
    </div>
  );
}
